function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import Moment from 'react-moment';
import Context from "../../services/context";
/**
 * Formatte la date passée en tant qu'enfant.
 */

export default (function (_ref) {
  var _ref$date = _ref.date,
      date = _ref$date === void 0 ? true : _ref$date,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? false : _ref$time,
      _ref$seconds = _ref.seconds,
      seconds = _ref$seconds === void 0 ? false : _ref$seconds,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["date", "time", "seconds", "children"]);

  var state = useContext(Context);

  if (children === null || !state || !state.locale) {
    return null;
  }

  if (typeof children !== 'string') {
    throw new Error('Only string nodes are accepted as children');
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, date && /*#__PURE__*/React.createElement(Moment, _extends({
    locale: state.locale,
    format: "L"
  }, props), children), time && /*#__PURE__*/React.createElement(Moment, _extends({
    className: "ml-1",
    locale: state.locale,
    format: seconds ? 'LTS' : 'LT'
  }, props), children));
});